/* Opciones de la página comercial.
   Para sumar algo, editá este archivo y recargá el navegador.
   No hace falta tocar el motor ni Premiere. */
window.EQUINOX_OPCIONES = {
  /* Aparecen al buscar en Absolute.
     category: "video-effects" | "audio-effects" | "user-presets"
     Ejemplo:
     { id: "pagina:glow", name: "Glow", category: "video-effects", searchText: "glow brillo" }
  */
  absolute: [],

  /* Tarjetas extra en Equinox → My Addons.
     href es relativo a la carpeta equinox/. Si no hay href, el click solo avisa.
     Ejemplo:
     { id: "silence", name: "Silence Cut", description: "Corta por silencios.", version: "0.1.0", href: "../notes/index.html" }
  */
  equinox: []
};
